/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for creating a tutorial tag.
 * @export
 * @interface TutorialTagCreate
 */
export interface TutorialTagCreate {
    /**
     * 
     * @type {string}
     * @memberof TutorialTagCreate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagCreate
     */
    description?: string | null;
}

/**
 * Check if a given object implements the TutorialTagCreate interface.
 */
export function instanceOfTutorialTagCreate(value: object): value is TutorialTagCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TutorialTagCreateFromJSON(json: any): TutorialTagCreate {
    return TutorialTagCreateFromJSONTyped(json, false);
}

export function TutorialTagCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialTagCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TutorialTagCreateToJSON(json: any): TutorialTagCreate {
    return TutorialTagCreateToJSONTyped(json, false);
}

export function TutorialTagCreateToJSONTyped(value?: TutorialTagCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

